import { render, staticRenderFns } from "./DemoSection.vue?vue&type=template&id=3a636a48&scoped=true&"
import script from "./DemoSection.vue?vue&type=script&lang=js&"
export * from "./DemoSection.vue?vue&type=script&lang=js&"
import style0 from "./DemoSection.vue?vue&type=style&index=0&id=3a636a48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a636a48",
  null
  
)

export default component.exports